var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.1959 9.33976C11.3721 8.83889 11.7199 8.41653 12.1776 8.1475C12.6354 7.87847 13.1736 7.78013 13.6969 7.86989C14.2203 7.95965 14.6949 8.23173 15.0369 8.63793C15.3788 9.04413 15.5659 9.55824 15.5652 10.0892C15.5652 11.5881 13.3168 12.3375 13.3168 12.3375M13.3458 15.3375H13.3558M13.1959 20.3375C17.8903 20.3375 21.6959 16.5319 21.6959 11.8375C21.6959 7.1431 17.8903 3.33752 13.1959 3.33752C8.50149 3.33752 4.69591 7.1431 4.69591 11.8375C4.69591 12.7875 4.85176 13.7011 5.13928 14.5541C5.24748 14.8751 5.30158 15.0356 5.31134 15.159C5.32098 15.2807 5.31369 15.3661 5.28357 15.4845C5.25306 15.6043 5.18571 15.729 5.05101 15.9783L3.41535 19.0059C3.18204 19.4377 3.06538 19.6537 3.09149 19.8203C3.11423 19.9654 3.19966 20.0932 3.32509 20.1698C3.46909 20.2576 3.71321 20.2324 4.20146 20.1819L9.32248 19.6525C9.47756 19.6365 9.5551 19.6285 9.62577 19.6312C9.69529 19.6339 9.74436 19.6404 9.81215 19.656C9.88107 19.6719 9.96773 19.7053 10.1411 19.7721C11.0891 20.1373 12.1191 20.3375 13.1959 20.3375Z",
    stroke: "#7BA4D5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.c5ee46816f5f7a210ede29c9957c4024.svg";
export { ForwardRef as ReactComponent };